import React from 'react';

/**
 * Seasonal block — toggled by CORP_CHRISTMAS_ENABLED on the backend.
 * Swap copy here in January 2027 without touching the core landing page.
 */
const CorpChristmas = ({ onOrder }) => (
  <section className="ff-section ff-section-alt" data-testid="corp-christmas" style={{ paddingTop: 40, paddingBottom: 40 }}>
    <div className="ff-container ff-card" style={{
      padding: '28px 32px', display: 'flex', flexWrap: 'wrap', gap: 24,
      alignItems: 'center', justifyContent: 'space-between',
      background: 'linear-gradient(135deg, #722F37, #4A2E1E)',
      color: 'var(--ff-cream)', border: '1px solid rgba(201,169,97,0.35)',
    }}>
      <div style={{ flex: '1 1 320px' }}>
        <p style={{ margin: 0, letterSpacing: 2, fontSize: 12, color: '#C9A961', fontWeight: 700 }}>
          CHRISTMAS 2026 · START 2027 RIGHT
        </p>
        <h2 style={{ margin: '6px 0 8px', color: 'var(--ff-cream)', fontSize: 28 }}>
          Christmas Is Closer Than You Think.
        </h2>
        <p style={{ margin: 0, opacity: 0.9, fontSize: 15, lineHeight: 1.6 }}>
          Businesses leave client gifting until the last minute — every year. Your best
          clients deserve more than another generic gift basket. Create custom wine for
          your clients, employees and partners this Christmas, complete with a label
          designed around your business.
        </p>
        <p style={{ margin: '10px 0 0', opacity: 0.85, fontSize: 13, fontStyle: 'italic' }}>
          Finish 2026 with a thank-you. Start 2027 with a relationship.
        </p>
      </div>
      <button onClick={onOrder} className="ff-btn ff-btn-gold ff-btn-lg" data-testid="corp-christmas-cta">
        Start My Christmas Order
      </button>
    </div>
  </section>
);

export default CorpChristmas;
